import router from './router'
import store from './store'
import NProgress from 'nprogress'
import { Message } from 'element-ui'
import { getToken } from '@utils/auth'
const whiteList = ['/login', '/bindAccount', '/404'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  // console.log('to', to.fullPath, from.fullPath, new Date().getTime())
  NProgress.start() // 开启Progress
  if (getToken() && !to.fullPath.includes('account')) {
    // 判断是否有token
    if (to.path === '/login') {
      console.log(store.getters['permission/permissionList'])
      store.getters['permission/permissionList'].length > 0
        ? next({ path: store.getters['permission/permissionList'][0].path })
        : next()
      NProgress.done()
    } else {
      if (!store.getters['user/role'] && store.getters['user/role'] !== 0) {
        // 判断当前用户是否已拉取完user_info信息
        ;(async () => {
          try {
            const res = await store.dispatch('user/GetInfo')
            const role = res.role
            await store.dispatch('permission/GetRouterList', role)
            router.addRoutes(store.getters['permission/permissionList'])
            if (
              store.getters['permission/permissionList']
                .map(item => item.path)
                .includes(to.path)
            ) {
              next(to.fullPath)
            } else {
              next({
                path: store.getters['permission/permissionList'][0].path,
              })
            }
          } catch (error) {
            await store.dispatch('user/FeLogout')
            Message.error('验证失败,请重新登录')
            next({ path: '/login' })
          }
        })()
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
